import { render, staticRenderFns } from "./MyRate.vue?vue&type=template&id=38425f8c&scoped=true"
import script from "./MyRate.vue?vue&type=script&lang=js"
export * from "./MyRate.vue?vue&type=script&lang=js"
import style0 from "./MyRate.vue?vue&type=style&index=0&id=38425f8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38425f8c",
  null
  
)

export default component.exports